import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import VueYouTubeEmbed from 'vue-youtube-embed'
import {router} from './router'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ru-RU'
import YmapPlugin from 'vue-yandex-maps'
import Croppa from 'vue-croppa'
import VTooltip from 'v-tooltip'

// styles
import '@/assets/app.sass'
import 'vue-croppa/dist/vue-croppa.css'
import './assets/main.css'


const SENTRY_DSN = process.env.VUE_SENTRY_DSN;
if (SENTRY_DSN) {
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [new Integrations.Vue({
            Vue,
            attachProps: true
        })]
    })
}


Vue.config.productionTip = false;

Vue.use(ElementUI, {
  locale
});
Vue.use(VueYouTubeEmbed);

Vue.use(Croppa);

const settings = {
  apiKey: process.env.VUE_APP_YA_API || '',
  lang: 'ru_RU',
  version: '2.1'
};
Vue.use(YmapPlugin, settings);

Vue.use(VTooltip, {defaultDelay:{show:500}})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
